import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableHead from "@mui/material/TableHead";
import "./DeviceManagementTable.scss";
import EditIcon from "../../images/editpencil.svg";
import BaseCustomerTable from "../BaseCustomerTable/BaseCustomerTable";
import { CheckCircle, OfflineBolt } from "@mui/icons-material";
import { getCountryFlagUrl } from "../../util/utilfunctions/utilFunctions";

function DeviceManagement(name, email, phone, address, country) {
  return { name, email, phone, address, country };
}

export default function DeviceManagementTable({
  userData,
  handleSelectedUser,
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(15);
  const [sorting, setSorting] = useState({ column: null, direction: "asc" });

  const pageCount = Math.ceil(userData.length / rowsPerPage);
  const pageNumbers = Array.from({ length: pageCount }, (_, index) => index);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  let fakeLiquid = [
    9210, 9452, 2640, 5336, 8973, 8373, 3097, 4225, 838, 5717, 2565, 9233, 1877,
    3777, 5103, 4838, 1065, 3588, 6284, 9544,
  ];
  let fakeConsumable = [
    "29%",
    "40%",
    "23%",
    "37%",
    "14%",
    "55%",
    "16%",
    "90%",
    "68%",
    "17%",
    "53%",
    "13%",
    "13%",
    "35%",
    "47%",
    "45%",
    "18%",
    "33%",
    "32%",
    "75%",
  ];

  const handleSort = (columnName) => {
    const isAsc = sorting.column === columnName && sorting.direction === "asc";
    setSorting({
      column: columnName,
      direction: isAsc ? "desc" : "asc",
    });
  };

  const sortedData = [...userData].sort((a, b) => {
    if (!sorting.column) return 0;

    let aValue = a.Vmerchantpi[sorting.column];
    let bValue = b.Vmerchantpi[sorting.column];

    const isAsc = sorting.direction === "asc";
    if (aValue < bValue) {
      return isAsc ? -1 : 1;
    }
    if (aValue > bValue) {
      return isAsc ? 1 : -1;
    }
    return 0;
  });

  const randomArray = [4, 1, 5, 5, 5, 4, 4, 1, 4, 4, 1, 4, 1, 2, 4];

  return (
    <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
      <Table sx={{ minWidth: 800 }} aria-label="custom pagination table">
        <TableHead>
          <TableRow>
            {/* <TableCell style={{ width: 50 }}>
              <img src={UserIcon} alt="User Icon" />
            </TableCell> */}
            <TableCell
              align="left"
              className="agent-table-header"
              style={{ width: 200 }}
              // onClick={() => handleSort("businessname")}
            >
              Name
            </TableCell>
            <TableCell
              align="left"
              style={{ width: 200 }}
              className="agent-table-header"
            >
              Country
            </TableCell>
            <TableCell
              align="left"
              style={{ width: 200 }}
              className="agent-table-header"
            >
              Zone
            </TableCell>
            <TableCell
              align="left"
              className="customer-table-headers"
              style={{ width: 200 }}
            >
              Float
            </TableCell>
            <TableCell
              align="left"
              className="customer-table-headers"
              style={{ width: 200 }}
            >
              Consumable
            </TableCell>
            <TableCell
              align="left"
              className="customer-table-headers"
              style={{ width: 150 }}
            >
              Status
            </TableCell>
            {/* <TableCell
              align="left"
              className="customer-table-headers"
              style={{ width: 200 }} // Adjusted width for Address
            >
              Address
            </TableCell> */}
            <TableCell
              align="right"
              className="customer-table-headers"
              style={{ width: 100 }} // Adjusted width for Edit
            >
              Details
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedData
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => (
              <TableRow key={row.Vmerchantpi.userid}>
                {/* <TableCell component="th" scope="row" style={{ width: 50 }}>
                  <img
                    src={
                      row.Vuser.photo === ""
                        ? UserFace
                        : imageUrl + row.Vuser.photo
                    }
                    className="table-customer-photo"
                    alt="User Image"
                  />
                </TableCell> */}
                <TableCell style={{ width: 200 }} align="left">
                  {row.Vmerchantpi.businessname}
                </TableCell>
                <TableCell style={{ width: 200 }} align="left">
                  {/* <Flag
                    code={row.Vmerchantpi.businesscountry}
                    height="18"
                    fallback={<span>Unknown</span>}
                  /> */}
                  <img 
                    src={getCountryFlagUrl(row.Vmerchantpi.businesscountry)} 
                    alt={row.Vmerchantpi.businesscountry} 
                    width="30" 
                    height="20"
                    style={{ borderRadius: "3px" }}
                    onError={(e) => e.target.src = "path-to-default-flag.png"}
                    loading="lazy"
                  />
                </TableCell>
                <TableCell style={{ width: 200 }} align="left">
                  {randomArray[index]}
                </TableCell>
                <TableCell style={{ width: 200 }} align="left">
                  ${fakeLiquid[index]}
                </TableCell>
                <TableCell style={{ width: 200 }} align="left">
                  {fakeConsumable[index]}
                </TableCell>

                <TableCell style={{ width: 150 }} align="left">
                  {row.Vmerchantpi.allowed == "1" ? (
                    <div>
                      <CheckCircle sx={{ color: "#25d366" }} />
                      <span className="px-2">Online</span>
                    </div>
                  ) : (
                    <div>
                      <OfflineBolt sx={{ color: "red" }} />
                      <span className="px-2"> Offline</span>
                    </div>
                  )}
                  {/* {row.Vuser.telephoneno} */}
                </TableCell>

                <TableCell style={{ width: 100 }} align="right">
                  <div className="d-flex justify-content-end agent-detail-container">
                    <a
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasRightLoan"
                      aria-controls="offcanvasRightLoan"
                    >
                      <img
                        src={EditIcon}
                        onClick={() => handleSelectedUser(row)}
                        alt="Edit Icon"
                        className="edit-icon-crm"
                      />
                    </a>
                  </div>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <BaseCustomerTable
        page={page}
        onPageChange={handleChangePage}
        pageNumbers={pageNumbers}
      />
    </TableContainer>
  );
}
